<template>
  <v-dialog :value="isActive" @click:outside="$emit('update:isActive', false)" width="600px">
    <v-card v-if="role">
      <v-card-title class="primary white--text d-flex justify-space-between">
        <span>{{ role.name }}</span>
        <v-btn text icon dark @click="$emit('update:isActive', false)">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-container>
        <v-row no-gutters>
          <v-col cols="12">
            <v-list v-for="permission in permissions" :key="permission.id">
              <v-list-item>
                <v-list-item-action>
                  <v-switch
                    inset
                    :input-value="checkPermission(permission)"
                    @change="togglePermission(permission)"
                    color="primary"
                    ripple
                  />
                </v-list-item-action>
                <v-list-item-title>{{ permission.name }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-col>
        </v-row>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    isActive: { required: true, type: Boolean },
    role: {
      default: () => {},
      type: Object,
    },
  },
  data() {
    return {
      permissions: [],
      key: 1,
    };
  },

  computed: {
    url() {
      if (this.role && this.role.id) {
        return `api/v1/admin/roles/${this.role.id}`;
      }
      return "api/v1/admin/roles";
    },
  },
  async created() {
    await this.fetchPermissions();
  },
  methods: {
    async fetchPermissions() {
      await this.$http
        .get(`api/v1/admin/permissions/all`)
        .then((data) => {
          this.permissions = data;
        })
        .catch((error) => {
          Notify.errorFromResponse(error, { close: true });
        });
    },
    checkPermission(permission) {
      const permissions = this.role.permissions.map((permission) => permission.id);
      return permissions.includes(permission.id);
    },
    async togglePermission(permission) {
      const { id } = permission;
      const hasCurrentPermission = this.checkPermission(permission);
      this.isActivating = true;
      if (!hasCurrentPermission) {
        await this.$http
          .post(`api/v1/admin/permissions/${id}`, { role_id: this.role.id })
          .then(() => {
            this.$emit("update:role");
            Notify.success("Operation was success full");
          })
          .catch((error) => {
            Notify.errorFromResponse(error, { close: true });
            this.$emit("update:role");
          })
          .finally(() => (this.isActivating = false));
      } else {
        await this.$http
          .put(`api/v1/admin/permissions/${id}`, { role_id: this.role.id })
          .then(() => {
            this.$emit("update:role");
            Notify.success("Operation was success full");
          })
          .catch((error) => {
            Notify.errorFromResponse(error, { close: true });
            this.$emit("update:role");
          })
          .finally(() => (this.isActivating = false));
      }
    },
  },
};
</script>
